import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';

import { CompanyService } from '@app/core/client-user';
import { Company } from '@app/core/client-user/store/company.model';

@Component({
  selector: 'filter-company',
  templateUrl: './filter-company.component.html',
  styleUrls: ['./filter-company.component.scss'],
})
export class FilterCompanyComponent implements OnInit {
  constructor(
    public companySvc :CompanyService,
    private cd :ChangeDetectorRef,
  ) {}

  @Input() value :number;
  @Input() label :string = 'Company';
  @Output() changeCompany :EventEmitter<number[] | number> = new EventEmitter<
    number[] | number
  >();
  @Input() options :{ multi :boolean } = { multi: false };
  companies$ :Observable<Company[]>;
  companyInput$ = new Subject<string>();
  companies :Company[] = [];
  private onDestroy$ = new Subject();

  ngOnInit() :void {
    this.companies$ = this.companySvc.companies$;
    this.onInputCompanyUpdated().subscribe();
    if (this.value) {
      this.getCompanyByIds([this.value]);
    } else {
      this.companySvc.getRecords();
    }
  }

  onChange() {
    this.changeCompany.emit(this.value);
  }

  customSearchFn(term :string, item :Company) {
    term = term.toLocaleLowerCase();

    return item.business_name
      .toLowerCase()
      .replace(/&nbsp;/gi, '')
      .includes(term);
  }

  private onInputCompanyUpdated() :Observable<string> {
    return this.companyInput$.asObservable().pipe(
      debounceTime(500), // 0.5 sec delay
      distinctUntilChanged(),
      tap((name :string) => {
        this.companySvc.search(name);
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getCompanyByIds(companyIds :number[]) :void {
    this.companySvc
      .getCompanyByIds(companyIds)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((response) => {
        if (response.data?.length > 0) {
          this.companies = response.data;
          this.companySvc.setCompanies(response.data);
          this.cd.detectChanges(); // Manually trigger change detection
        }
      });
  }

  get businessName() :string {
    const item = this.companies.find(
      (company) => company.id === Number(this.value),
    );

    return item ? item.business_name : '';
  }
}
